export default {
    AdditionalPageTypes: true,
    Admin: true,
    Advertising: false,
    Advertising2: {
        adServers: ["simple"],
        adSizes: ["mpu", "banner", "banner-large"]
    },
    AggregatedContentFeed: true,
    AllowCustomFields: false,
    AppConfig: false,
    AppEcommerceManager: true,
    AppScorePredictor: false,
    AppSocialManager: true,
    AppTicketingManager: true,
    BreakingNews: true,
    BuildManager: true,
    Calendar: false,
    ConfigManager: true,
    CustomCommentary: true,
    CustomLineups: true,
    CustomTables: true,
    CustomTags: false,
    Dashboard: true,
    Fixtures: true,
    Forms: true,
    HomepageManager: true,
    HomepageNewsPromo: false,
    HomepagePlayerHighlight: false,
    Lab: false,
    MapDirectory: false,
    MatchdayTakeover: true,
    MatchCentre2: true,
    Media: true,
    MFA: false,
    News: true,
    OptaIntegration: true,
    Organisations: false,
    OverlayPromos: true,
    Pages: true,
    PlatformOptions: true,
    PlayerVoting: false,
    PreventEntitlementEmails: false,
    Profile: true,
    RelatedContentTagging: true,
    RewardsManager: false,
    RewardPoints: false,
    Rover: false,
    Settings: false,
    SiteConfig: true,
    SocialContentFeed: true,
    Sponsors: true,
    Squads: true,
    SsoUsers: true,
    StreamAMGIntegration: false,
    Streamline: true,
    StreamlineAdverts: false,
    StreamlineAutoSubtitles: true,
    StreamlinePromoCodes: false,
    StreamlinePro: true,
    Streamline2: true,
    TourManagement: false,
    Videos: true,
    Voice: false,
    WebStats: true
}
